export default __webpack_public_path__ + "static/media/person-shield.7fadc145.svg";